export default __webpack_public_path__ + "static/media/4573971.519d021a.png";